import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const libraryUpdateSlice = createSlice({
  name: 'libraryUpdate',
  initialState: { libraryUpdate: initialState },
  reducers: {
    libraryUpdateApi: (state, data) => {
      state.libraryUpdate = data.payload;
    },
  },
});

export const { libraryUpdateApi } = libraryUpdateSlice.actions;

export default libraryUpdateSlice.reducer;
